import BaseComponent from "./BaseComponent";
import Dropdown from "./Dropdown";

export class ExceptionHandling extends BaseComponent {
    /**
     * Global exception handling
     * @module ExceptionHandling
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            exception: '',
            timeout: ''
        }
    }

    componentDidMount(){
        this.updateUIState();
    }

    initDataModel(){
        if (!window.apm.serialized.globalExceptionHandling){
            console.error("serialized missing ExceptionHandling");
            window.apm.serialized.globalExceptionHandling = {
                exception: null,
                timeout: null
            };
        }
    }

    setConfig(key, value){
        window.apm.serialized.globalExceptionHandling[key] = value;
        this.updateUIState();
        window.apm.serialized.globalExceptionHandling.lastLocalChange = window.apm.timestamp;
        window.apm.setSerializedChanged();
    }

    getConfig(key){
        return window.apm.serialized.globalExceptionHandling[key];
    }
    moduleOptions(){
        const modules = window.apm.knowledgeBase.getModules();
        return modules.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }

    UNSAFE_componentWillReceiveProps(){
        this.updateUIState();    
    }

    /**
     * Control the UI (dropdowns) via state
     */
     updateUIState(){
        this.setState({exception: this.getConfig("exception")});
        this.setState({timeout: this.getConfig("timeout")});
    }

    render(){

        const exceptionSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.exception, this.moduleOptions());
        const timeoutSelected = window.apm.knowledgeBase.getIndexFromValue(this.state.timeout, this.moduleOptions());
        const errorMessage  = "Cannot be Empty";
        
        return (
            <div className="row">
                <div className="col-md-6">
                    <Dropdown
                        context={this}
                        label={window.l.settings.exception_or_error}
                        tooltip="Defines which module is called if the Process Engine encounters an exception."
                        optionName={window.l.settings.select_module}
                        options={this.moduleOptions()}
                        valKey={"exception"}
                        selection={exceptionSelected}
                        showError = {exceptionSelected ===-1}
                        errorMessage = {errorMessage}
                    />
                </div>
                <div className="col-md-6">
                    <Dropdown
                        context={this} 
                        label={window.l.settings.timeout_error}
                        tooltip="Defines which module is called if the Process Engine encounters a timeout."
                        optionName={window.l.settings.select_module}
                        options={this.moduleOptions()}
                        valKey={"timeout"}
                        selection={timeoutSelected}
                        showError = {timeoutSelected ===-1}
                        errorMessage = {errorMessage}
                    />
                </div>
            </div>
        );
    }
}